import { GuidelineDTO, UwEligibility, UwGuideline } from 'types/uwService';
import { GET_GUIDELINES, GET_UW_BY_PERIOD_ID } from 'api/queries/uwService';
import apolloClient from 'api/apolloClient';

export const INITIAL_UW_RESULT_OBJECT: UwEligibility = Object.freeze({
  guidelines: [],
  result: [],
});

export const getUwByEnrollmentPeriodId = async (groupId: string, periodId: string): Promise<UwEligibility> => {
  const res = await apolloClient.query<{ getUwResultByPeriodId: UwEligibility }>({
    query: GET_UW_BY_PERIOD_ID,
    fetchPolicy: 'no-cache',
    variables: { groupId, periodId },
  });
  return res.data.getUwResultByPeriodId;
};

export const getGuidelines = async (guidelineDTOs: GuidelineDTO[]): Promise<UwGuideline[]> => {
  const res = await apolloClient.query<{ getGuidelines: UwGuideline[] }>({
    query: GET_GUIDELINES,
    variables: { guidelineDTOs },
  });
  return res.data.getGuidelines;
};
